import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ClientsPage from "./Pages/ClientsPage.js";

import Login from "./Login";
import NotificationsPage from "./Pages/NotificationsPage.js";
import Register from "./Register";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";

import NewCompany from "./Pages/NewCompany.js";
import EditCompanyPage from "./Pages/EditCompanyPage.js";
import NotificationTypesPage from "./Pages/NotificationTypesPage.js";
import NewNotificationTypePage from "./Pages/NewNotificationTypePage.js";
import NotificationTypeDetailPage from "./Pages/NotificationTypeDetailPage.js";
import NewNotificationPage from "./Pages/NewNotificationPage.js";
import ClientDetailPage from "./Pages/ClientDetailPage.js";

import { ToastContainer } from "react-toastify";

import Companies from "./Pages/CompaniesPage.js";
import NewClientPage from "./Pages/NewClientPage.js";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route element={<PublicRoute />}>
            <Route path="/register" element={<Register />} />
          </Route>

          <Route element={<PublicRoute />}>
            <Route path="/login" element={<Login />} />
          </Route>

          <Route path="/" element={<PrivateRoute />}>
            <Route path="/" element={<ClientsPage />} />
          </Route>

          <Route path="/companies" element={<PrivateRoute />}>
            <Route path="/companies" element={<Companies />} />
          </Route>

          <Route path="/create-company" element={<PrivateRoute />}>
            <Route path="/create-company" element={<NewCompany />} />
          </Route>

          <Route path="/edit-company/:companyId" element={<PrivateRoute />}>
            <Route
              path="/edit-company/:companyId"
              element={<EditCompanyPage />}
            />
          </Route>

          <Route path="/notification-types" element={<PrivateRoute />}>
            <Route
              path="/notification-types"
              element={<NotificationTypesPage />}
            />
          </Route>

          <Route path="/new-notification-type" element={<PrivateRoute />}>
            <Route
              path="/new-notification-type"
              element={<NewNotificationTypePage />}
            />
          </Route>

          <Route
            path="/edit-notification-type/:notificationTypeId"
            element={<PrivateRoute />}
          >
            <Route
              path="/edit-notification-type/:notificationTypeId"
              element={<NotificationTypeDetailPage />}
            />
          </Route>

          <Route path="/notifications" element={<PrivateRoute />}>
            <Route path="/notifications" element={<NotificationsPage />} />
          </Route>

          <Route path="/new-notification" element={<PrivateRoute />}>
            <Route path="/new-notification" element={<NewNotificationPage />} />
          </Route>

          <Route path="/create-client" element={<PrivateRoute />}>
            <Route path="/create-client" element={<NewClientPage />} />
          </Route>

          <Route path="/edit-client/:clientId" element={<PrivateRoute />}>
            <Route
              path="/edit-client/:clientId"
              element={<ClientDetailPage />}
            />
          </Route>
        </Routes>
      </Router>

      <ToastContainer />
    </>
  );
}

export default App;
